import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import Spinner from '../../misc/Spinner';
import {getEudiwIdentStatus} from '../../../lib/emmiApi';
import {useNavigate} from 'react-router-dom';
import MethodTitle from "../../misc/Method-title/MethodTitle";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import {useI18nContext} from "../../i18n/I18nContext";
import LOG from "wipi-common/src/lib/logging/logger";
import {LOG_EVENTS} from "wipi-common/src/lib/logging/events";

export default function EudiwIdPolling({caseInfo}) {
    const navigate = useNavigate();
    const context = useI18nContext();

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.EW_POLLING)
        let cancelled = false;
        async function poll() {
            try {
                LOG.logInfo(LOG_EVENTS.EW_POLLING_START)
                let result;
                do {
                    if (cancelled) {
                        return;
                    }
                    result = await getEudiwIdentStatus(caseInfo.caseId);
                    if (result.statusCode === 881 || result.statusCode === 880) {
                        LOG.logInfo(LOG_EVENTS.EW_POLLING_STOP, 'success with status code ' + result.statusCode)
                        navigate('/eudiwid/success?caseId=' + caseInfo.caseId);
                        return;
                    }
                    if (result.statusCode === 850 || result.statusCode === 870 || result.statusCode === 871) {
                        LOG.logInfo(LOG_EVENTS.EW_POLLING_STOP, 'error with status code ' + result.statusCode)
                        navigate('/eudiwid/error');
                        return;
                    }
                    await new Promise(resolve => setTimeout(resolve, 5000));
                } while (result.statusCode !== 881);
            } catch (e) {
                navigate('/eudiwid/error');
            }
        }
        poll();
        return () => { cancelled = true; };
    }, [caseInfo, navigate]);


    return (
        <>
            <div className="headless">
                <div className="col-xl-6 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-12">
                    <div className="row max-w-75 mx-auto">
                        <MethodTitle
                            heading={getI18nTextWithContext(context, 'startEudiwId.heading')}
                            subHeading={null}
                            info={null}
                            testId="hfmvwi41a4p9"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-6 offset-xxl-0 col-xl-6 offset-xl-0 col-lg-6 offset-lg-0 col-md-8 offset-md-0 col-sm-8 col-12 d-flex flex-column justify-content-center">
                        <Spinner />
                        {getI18nTextWithContext(context, 'eudiwIdPolling.description')}
                    </div>
                </div>
            </div>
        </>
    );
}

EudiwIdPolling.propTypes = {
    caseInfo: PropTypes.object.isRequired
};
